import RootLayout from "@/app/layout";
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box, Container } from '@mui/material';
import { Link } from "@nextui-org/react";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import data from '../../data/faq/data.json';
import Head from "next/head";

export const metadata = {
  title: 'Hebamme Lea Stiffler | FAQ',
  description: 'Häufig gestellte Fragen zur Hebammenbetreuung in Chur. Erfahren Sie alles über Schwangerschaftsbetreuung, Geburtsvorbereitung, Hausgeburt, Versicherungsleistungen und mehr.',
  keywords: 'FAQ Hebamme, Hebammenbetreuung Chur, Schwangerschaftsbetreuung Fragen, Geburtsvorbereitungskurs, Hausgeburt Hebamme, Krankenversicherung Hebammenleistungen',
  canonicalUrl: 'https://hebamme-leastiffler.ch/faq'
}

export async function getStaticProps() {
  return { props: { data } }
}

export default function Faq({ data }) {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });
  return (
    <RootLayout>
      <Head>
        <title>{metadata.title}</title>
        <meta name="description" content={metadata.description} />
        <meta name="keywords" content={metadata.keywords} />
        <link rel="canonical" href={metadata.canonicalUrl} />
      </Head>
      <motion.section
        className="section-large"
        ref={ref}
        initial={{ opacity: 0 }}
        animate={{ opacity: inView ? 1 : 0 }}
        transition={{ duration: 1 }}
      >
        <div className="section-header">
          <div className="section-title">
            <Typography variant="h3" component="h1" gutterBottom align="center">
              {data.Titel}
            </Typography>
          </div>
        </div>
        <div className="section-body">
          <Container maxWidth="lg">
            <Box sx={{ mx: 2, mb: 2 }}>
              {data.Faq.map((p, index) => (
                <Accordion key={index} sx={{ my: 2 }}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`panel${index}-content`}
                    id={`panel${index}-header`}
                  >
                    <Typography variant="h6" component="h2">{p.Frage}</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body1" color="text.secondary" paragraph>
                      {p.Antwort}
                    </Typography>
                    {p.Link ?
                      <Link href={p.Link} target="_blank">
                        Mehr dazu
                      </Link> : <></>}
                  </AccordionDetails>
                </Accordion>
              ))}
            </Box>
          </Container>
        </div>
      </motion.section>
    </RootLayout>
  );
}

